export const APP_NAME = "Open Access GPT";